<script lang="ts">
  import type { Snippet } from 'svelte';
  import Button from '../ui/Button.svelte';
  import InlineMessage from '../ui/InlineMessage.svelte';

  /** Status line, empty state and Refresh/More actions around one paged list query. */
  interface Props {
    error: string;
    /** First load with no rows yet. */
    loading: boolean;
    loadingMessage: string;
    /** Loaded without error and without rows. */
    empty: boolean;
    emptyMessage: string;
    fetching: boolean;
    fetchingNextPage: boolean;
    hasNextPage: boolean;
    moreLabel: string;
    refresh: () => void;
    more: () => void;
    children: Snippet;
  }
  let {
    error,
    loading,
    loadingMessage,
    empty,
    emptyMessage,
    fetching,
    fetchingNextPage,
    hasNextPage,
    moreLabel,
    refresh,
    more,
    children,
  }: Props = $props();
  const refreshing = $derived(fetching && !fetchingNextPage);
</script>

<InlineMessage intent={error ? 'error' : 'info'} message={error || (loading ? loadingMessage : '')} />
{#if empty}
  <p class="empty-state">{emptyMessage}</p>
{/if}
{@render children()}
<div class="row">
  <Button variant="ghost" size="small" aria-busy={refreshing} disabled={fetching} onclick={refresh}
    >{refreshing ? 'Loading…' : 'Refresh'}</Button
  >
  {#if hasNextPage}<Button size="small" aria-busy={fetchingNextPage} disabled={fetching} onclick={more}
      >{fetchingNextPage ? 'Loading…' : moreLabel}</Button
    >{/if}
</div>

<style>
  .empty-state {
    padding: 30px 0;
    text-align: center;
    font-size: 14px;
  }
</style>
